import { useEffect, useState } from "react";
import { IPaymentConfig } from "../../models";
import { getPaymentConfigApi } from "./paymentApi";

const OFF: IPaymentConfig = { mode: "off", recaptchaSiteKey: "", isTest: false };

// One request per page load, shared by every component that asks.
let pending: Promise<IPaymentConfig> | null = null;
let loaded: IPaymentConfig | null = null;

const load = () => {
  if (!pending) {
    pending = getPaymentConfigApi().then((config) => {
      loaded = config;
      return config;
    });
  }
  return pending;
};

/**
 * Card payment settings from the server (NestPay.Mode in secrets.config).
 * - showBrands: card/bank logos and the terms link are shown ("on" or "soon")
 * - cardLive:   card payment actually works ("on")
 */
export const usePaymentConfig = () => {
  const [config, setConfig] = useState<IPaymentConfig>(loaded ?? OFF);

  useEffect(() => {
    let active = true;
    load().then((c) => {
      if (active) setConfig(c);
    });
    return () => {
      active = false;
    };
  }, []);

  return {
    config,
    showBrands: config.mode !== "off",
    cardLive: config.mode === "on",
  };
};
